import type { CardConfiguration, GooglePayConfiguration } from '@adyen/adyen-web';
import { ADYEN_CARD_STYLES } from './styles';

export const ADYEN_APPLE_PAY_TYPE = 'applepay';

/** Card secured-field iframe load failure — emitted by Adyen Card `onError`. */
export const ADYEN_SECURED_FIELD_IFRAMES_LOAD_ERROR = 'secured field iframes have failed to load';

export enum AdyenCheckoutErrorTypes {
  NETWORK_ERROR = 'NETWORK_ERROR',
  CANCEL = 'CANCEL',
  IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR',
  API_ERROR = 'API_ERROR',
  ERROR = 'ERROR',
  SCRIPT_ERROR = 'SCRIPT_ERROR',
  SDK_ERROR = 'SDK_ERROR',
}

export const ADYEN_GOOGLE_PAY_CONFIG: GooglePayConfiguration = {
  callbackIntents: [],
  showPayButton: true,
  isExpress: true,
  buttonSizeMode: 'fill',
  // Match `GooglePayButtonPlaceholder`'s `rounded-[6px]` so the real Adyen
  // Google Pay button keeps the same corner radius as the loading placeholder.
  buttonRadius: 6,
  emailRequired: true,
  assuranceDetailsRequired: true,
};

export const ADYEN_GOOGLE_PAY_TYPE = 'googlepay';

export const ADYEN_CARD_BRANDS = ['visa', 'mc', 'amex', 'discover', 'maestro', 'diners', 'jcb', 'cup'] as const;

export const ADYEN_PAYMENT_METHOD_TYPE = 'scheme';
export const ADYEN_PAYMENT_METHOD_NAME = 'Cards';

export const ADYEN_CARD_FIELD = 'encryptedCardNumber';
export const ADYEN_DATE_FIELD = 'encryptedExpiryDate';
export const ADYEN_CVC_FIELD = 'encryptedSecurityCode';

export const ADYEN_THREEDS_CONTAINER_ID = 'threeds-container';

export const ADYEN_3DS_CONTAINER_ID = 'adyen-card-3ds-form';

// Cadence of the order-state watchdog that runs while a 3DS challenge is
// pending. It is a read-only GET per tick and only for shoppers already inside
// a challenge, so it is deliberately slower than the 2s redirect polling.
export const ADYEN_3DS_ORDER_POLL_INTERVAL_MS = 5000;

export const ADYEN_CARD_CONFIG: CardConfiguration = {
  hasHolderName: true,
  holderNameRequired: true,
  billingAddressRequired: false,
  exposeExpiryDate: true,
  showPayButton: false,
  enableStoreDetails: false,
  showInstallmentAmounts: false,
  showStoreDetailsCheckbox: false,
  configuration: {
    socialSecurityNumberMode: 'hide',
  },
  showBrandIcon: false,
  styles: ADYEN_CARD_STYLES,
  hideCVC: false,
  showContextualElement: false,
  placeholders: {
    cardNumber: 'Card Number',
    expiryDate: 'MM/YY',
    securityCodeThreeDigits: 'CVC',
    securityCodeFourDigits: 'CVC',
    holderName: 'Cardholder Name',
  },
};
